<div class="sh-facet-list">
  @for (facet of facets; track facet) {
    <sh-facet
      [facet]="facet"
      [showMoreMsg]="showMoreMsg"
      [blockShowMore]="blockShowMore"
      (loadMore)="onLoadMore($event)"
      (valueSelected)="onValueSelected($event)"
      (selectionChanged)="onSelectionChange($event)"
    ></sh-facet>
  }
</div>
